import { ecsApi } from '@services';
import { GetSignatureResponse, SignaturePayload, SignatureResponse } from './signature.types';

export const signatureApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        saveSignature: builder.mutation<SignatureResponse, SignaturePayload>({
            query: (file) => ({
                url: '/users/signature',
                method: 'POST',
                body: file
            })
        }),
        getSignature: builder.mutation<GetSignatureResponse, void>({
            query: () => ({
                url: '/users/signature',
                method: 'GET'
            })
        })
    })
});

export const { useSaveSignatureMutation, useGetSignatureMutation } = signatureApi;
